import { render } from "./ProspectsTable.vue?vue&type=template&id=d1ff178a&scoped=true"
import script from "./ProspectsTable.vue?vue&type=script&lang=js"
export * from "./ProspectsTable.vue?vue&type=script&lang=js"

import "./ProspectsTable.vue?vue&type=style&index=0&id=d1ff178a&lang=scss&scoped=true"
import "./ProspectsTable.vue?vue&type=style&index=1&id=d1ff178a&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1ff178a"]])

export default __exports__